import React from "react"
import * as S from "./Title.styles"

export default function Title({ children }) {
  return <S.Title>{children}</S.Title>
}
